"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgAnimalsAndNature = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_ANIMALS-AND-NATURE", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M4.814 1.61a3 3 0 1 0-3.248 5.025c.28-.592.586-1.194.915-1.78a1 1 0 1 1 1.06-1.696c.4-.57.826-1.096 1.273-1.548ZM14.434 6.636A3 3 0 0 0 13 1c-.682 0-1.31.227-1.814.61.447.453.873.978 1.273 1.549a1 1 0 1 1 1.06 1.696c.33.586.635 1.188.915 1.78Z" }),
    React.createElement("path", { d: "M4.926 4.678c.599-.91 1.202-1.62 1.778-2.087C7.276 2.127 7.7 2 8 2c.3 0 .724.127 1.296.59.576.467 1.18 1.179 1.778 2.088 1.198 1.817 2.166 4.091 2.792 5.777.228.614.023 1.15-.354 1.42C12.027 12.933 9.994 14 8 14c-1.994 0-4.027-1.066-5.512-2.126-.377-.27-.582-.806-.354-1.419.626-1.686 1.594-3.96 2.792-5.777ZM15.74 9.759C14.452 6.287 11.62 0 8 0 4.381 0 1.548 6.287.259 9.76c-.508 1.369-.121 2.894 1.068 3.742C2.917 14.637 5.373 16 8 16s5.084-1.363 6.674-2.498c1.188-.848 1.575-2.373 1.067-3.743Z" }),
    React.createElement("path", { d: "M7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6.207 11.707c-.63-.63-.184-1.707.707-1.707h2.172c.89 0 1.337 1.077.707 1.707l-1.086 1.086a1 1 0 0 1-1.414 0l-1.086-1.086Z" }))); };
exports.default = SvgAnimalsAndNature;
